import qs from 'qs';
import { fetchPOST, fetchDELETE } from 'api/fetchHelper';

const PATH = '/_api/v1/bans';

const Bans = {
  ban: ({ userId, include, body } = {}) => {
    if (!userId) throw new Error('userId is not defined');
    return fetchPOST(`${PATH}?${qs.stringify({ include, user_id: `${userId}` }, { encodeValuesOnly: true })}`, body);
  },

  unban: ({ banId } = {}) => {
    if (!banId) throw new Error('banId is not defined');
    return fetchDELETE(`${PATH}/${banId}`);
  },
};

export default Bans;
